<div class="ft-share-to-links">
    @for (network of socialNetworks(); track network) {
        <a class="ft-icn-share-{{ network.name }}" [class.shared]="network.isSharedTo"
           (click)="shareTo(network)">
            {{ network.name | capitalize }}
        </a>
    }
</div>
